import * as service from '../../service/CallApi';
import {OTPConfirmRequest} from "../../models/RequestModel";
import {initSuccessResponse, SuccessResponse} from "../../models/ResponseModel";

const types = {
    OTP_PENDING_FETCH: "OTP_PENDING_FETCH",
    OTP_FETCH_SUCCESS: "OTP_FETCH_SUCCESS",
    OTP_FETCH_FAILURE: "OTP_FETCH_FAILURE"
}

export const actions = {
    postOTPConfirm: async (dispatch: any, request: OTPConfirmRequest) => {
        dispatch({type: types.OTP_PENDING_FETCH, message: ""})
        await service.postOTPConfirm(request).then(res => {
            if (res.status === 200) {
                const res: SuccessResponse = {status: true}
                dispatch({
                    type: types.OTP_FETCH_SUCCESS,
                    payload: res
                })
            } else {
                dispatch({type: types.OTP_FETCH_FAILURE})
            }
        }).catch( err => {
            dispatch({type: types.OTP_FETCH_FAILURE, message: err.message})
        })
    },
    setOTPConfirm: async (dispatch: any, status:boolean) => {
        dispatch({type: types.OTP_PENDING_FETCH, message: ""})
        const res: SuccessResponse = {status: status}
        dispatch({
            type: types.OTP_FETCH_SUCCESS,
            payload: res
        })
    }
}

const initialState = {
    otpConfirm: initSuccessResponse(),
    message: "",
    isFetching: false
};

export const otpConfirmReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.OTP_FETCH_SUCCESS:
            return {
                ...state,
                otpConfirm: action.payload,
                isFetching: false
            };
        case types.OTP_FETCH_FAILURE:
            return {
                ...state,
                message: action.message,
                isFetching: false
            };
        case types.OTP_PENDING_FETCH:
            return {
                ...state,
                isFetching: true
            }
        default:
            return state;
    }
}